var _excluded = ["skeleton", "src", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledMedia, StyledMediaEl, StyledMediaSkeleton } from './Styles';
function Media(_ref) {
  var skeleton = _ref.skeleton,
    src = _ref.src,
    title = _ref.title,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledMediaEl, null, skeleton && /*#__PURE__*/React.createElement(StyledMediaSkeleton, null), /*#__PURE__*/React.createElement(StyledMedia, _extends({}, rest, {
    src: !skeleton ? src : "",
    title: title,
    alt: rest.as === 'img' ? title : ""
  })));
}
Media.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Which image node to render as
   */
  as: PropTypes.oneOf(['div', 'img']),
  /**
   * Specifies the path to the image
   */
  src: PropTypes.string.isRequired,
  /**
   * If `true`, shows component in loading state
   */
  skeleton: PropTypes.bool,
  /**
   * Specifies an title & alternate text for an image
   */
  title: PropTypes.string
} : {};
Media.defaultProps = {
  as: 'div',
  skeleton: false,
  title: ''
};
export default Media;